import React from 'react';

type PageTitleContextType = {
    updateTitle: (title: string) => void;
};

export const PageTitleContext = React.createContext<PageTitleContextType>({
    updateTitle: () => {},
});
